import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import Logo_Dashboard from "../../../Images/Logo_Dashboard.png";
import Rectangle from "../../../Images/Rectangle_368.png";
import undraw_design_tools_ from "../../../Images/undraw_design_tools_-42-tf 1.png";
import "../../../CSS/customInput.css";

import {
  createUserAsync,
  fetchStateDataAsync,
  fetchIdProofDataAsync,
  selectStateOptions,
  selectIdProofOptions,
  selectDistrictOptions,
  selectError,
  selectStatus,
  checkEmailAsync,
  checkMobileAsync,
  fetchDistrictDataAsync,
} from "../authSlice";
import { useForm } from "react-hook-form";

import { Link, useNavigate } from "react-router-dom";

import RegistrationSuccessModal from "../../modal/RegistrationSuccessModal";
import EkycModal from "../../modal/EkycModal";
import {
  fetchRelationData,
  fetchGender,
  fetchIDTypeData,
} from "../../PartyDetail/PartyDetailSlice";

import {
  clearAadhaarDetails,
  selectAadhaarDetails,
  selectIsOTPVerified,
} from "../../property/AadhaarDetailsSlice";
import MobileEmailModal from "../../modal/MobileEmailModal";
import {
  clearOTPs,
  fetchOTPs,
} from "../../modal/modalSlices/MobileEmailModalSlice";
import { toast } from "react-toastify";
import TypewriterAnimation from "../../Loader/TypewriterAnimation";

const SignUpNew = () => {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const [selectedOption, setSelectedOption] = useState("without");
  const [isEkycModalOpen, setIsEkycModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const stateOptions = useSelector(selectStateOptions);
  // const idProofOptions = useSelector(selectIdProofOptions);
  const { idTypeData } = useSelector((state) => state.PartyDetail);
  const districtOptions = useSelector(selectDistrictOptions);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [pincode, setpincode] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [showIdentificationError, setShowIdentificationError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const error = useSelector(selectError);
  const status = useSelector(selectStatus);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const { relationData, genderData } = useSelector(
    (state) => state.PartyDetail
  );
  const isOTPVerified = useSelector(selectIsOTPVerified);
  const aadhaarDetails = useSelector(selectAadhaarDetails);
  const [Aadhaar_ekyc, setAadhaar_ekyc] = useState("N");
  const identificationType = watch("identificationType");
  //;
  const selectedState = watch("state");
  const [isMobileAdhaarModalOpen, setisMobileAdhaarModalOpen] = useState(false);
  const [mobileVerified, setMobileVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [whatsappVerified, setWhatsappVerified] = useState(false);
  const [requireWhatsapp, setRequireWhatsapp] = useState(false);
  const [isVerificationComplete, setIsVerificationComplete] = useState(false);
  const [formData, setFormData] = useState({}); // Store form data
  const isManualChange = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const mobileNo = watch("MobileNo");
  const emailAddr = watch("email");
  const whatsappNo = watch("WhatsApp_No");
  const [uploadPhoto, setuploadPhoto] = useState("");

  useEffect(() => {
    dispatch(fetchStateDataAsync());
    // dispatch(fetchIdProofDataAsync());
    dispatch(fetchIDTypeData());
    dispatch(fetchRelationData());
    dispatch(fetchGender());
  }, [dispatch]);

  useEffect(() => {
    // Whenever any of these three inputs change, reset everything
    dispatch(clearOTPs());
    setMobileVerified(false);
    setEmailVerified(false);
    setWhatsappVerified(false);
    setIsVerificationComplete(false);
  }, [mobileNo, emailAddr, whatsappNo, dispatch]);

  const handleAadhaarNumberChange = (number) => {
    setAadhaarNumber(number);
    console.log("Received Aadhaar Number from Modal:", number);
  };

  const handleEkycModalClose = (e) => {
    e.preventDefault();
    console.log("Closing modal");
    setIsEkycModalOpen(false);
  };

  useEffect(() => {
    if (
      identificationType === "04" &&
      selectedOption === "without" &&
      !isManualChange.current
    ) {
      setSelectedOption("with");
      setIsEkycModalOpen(true);
    }
    // Reset manual change flag after automatic selection
    isManualChange.current = false;
  }, [identificationType, selectedOption]);

  useEffect(() => {
    if (isOTPVerified === false) {
      setSelectedOption("without"); // Reset to "without" if modal is closed without completing e-KYC
    } else {
      setSelectedOption("with");
    }
    // if (isOTPVerified === true) {
    //   setSelectedOption("with");
    // }
  }, [dispatch, isOTPVerified, selectedOption]);

  useEffect(() => {
    if (selectedState) {
      dispatch(fetchDistrictDataAsync(selectedState));
    }
  }, [dispatch, selectedState]);

  useEffect(() => {
    if (
      aadhaarDetails &&
      aadhaarDetails.district &&
      districtOptions.length > 0
    ) {
      const districtID = districtOptions.find(
        (district) =>
          district.districtName.toLowerCase() ===
          aadhaarDetails.district.toLowerCase()
      )?.districtID;

      if (districtID) {
        setValue("district", districtID);
      }
    }
  }, [aadhaarDetails, districtOptions, setValue]);

  useEffect(() => {
    if (selectedOption === "without") {
      setAadhaar_ekyc("N");
      dispatch(clearAadhaarDetails());
      reset(); // Clear form values
    }
  }, [dispatch, selectedOption]);

  // Central validation patterns/messages
  const regexPatterns = {
    "01": {
      pattern: /^[A-Z]{3}[0-9]{7}$/,
      message: "Enter a valid Voter ID (3 letters + 7 digits)",
    },
    "02": {
      pattern: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
      message: "Enter a valid PAN (ABCDE1234F)",
    },
    "03": {
      pattern: /^[A-Z]{2}[0-9]{13}$/,
      message: "Enter a valid Driving Licence (2 letters + 13 digits)",
    },
    "04": {
      pattern: /^[0-9]{12}$/,
      message: "Enter a valid 12-digit Aadhaar number",
    },
    mobile: {
      pattern: /^[0-9]{10}$/,
      message: "Enter a valid 10-digit mobile number",
    },
    email: {
      pattern:
        /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[A-Za-z]{2,})+$/,
      message: "Enter a valid email",
    },
  };

  function validateAll(data) {
    // Mobile
    if (!regexPatterns.mobile.pattern.test(data.MobileNo)) {
      toast.error(regexPatterns.mobile.message);
      return false;
    }
    // if (!regexPatterns.mobile.pattern.test(data.WhatsApp_No)) {
    //   toast.error(regexPatterns.mobile.message.replace("mobile", "WhatsApp"));
    //   return false;
    // }
    // WhatsApp (optional) — validate only if user typed something
    if (data.WhatsApp_No) {
      if (!regexPatterns.mobile.pattern.test(data.WhatsApp_No)) {
        toast.error("Enter a valid 10-digit WhatsApp number");
        return false;
      }
    }
    // Email
    if (!regexPatterns.email.pattern.test(data.email)) {
      toast.error(regexPatterns.email.message);
      return false;
    }
    // Identification
    const rule = regexPatterns[data.identificationType];
    if (rule && !rule.pattern.test(data.identificationNumber)) {
      toast.error(rule.message);
      return false;
    }
    return true;
  }

  const handleFileChange = (event) => {
    debugger;
    const file = event.target.files[0]; // pick the first file
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    // check format
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, and PNG formats are allowed.");
      event.target.value = ""; // reset input
      return;
    }

    // convert to base64
    const reader = new FileReader();
    reader.onloadend = () => {
      debugger;
      setuploadPhoto(reader.result); // ✅ save base64 string in state
      console.log("Base64 Image:", reader.result);
    };
    reader.onerror = (error) => {
      console.error("Error converting file to base64:", error);
    };

    reader.readAsDataURL(file);
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();
    if (!validateAll(data)) return;
    setIsLoading(true);
    const requiredFields = [
      "firstName",
      "lastName",
      "gender",
      "DOB",
      "MobileNo",
      // "WhatsApp_No",
      "email",
      "identificationType",
      "identificationNumber",
      "relation",
      "fatherName",
      "category",
      "Relegion",
      "country",
      "state",
      "district",
      "villageTownCity",
      "house",
      "landmark",
      "street",
      "pincode",
      "username",
      "password",
      "confirmPassword",
    ]; // Replace with actual field names
    const missingFields = requiredFields.filter((field) => !data[field]);
    if (missingFields.length > 0) {
      // Display error messages for missing fields
      missingFields.forEach((field) => {
        setError(field, { type: "manual", message: `${field} is required` });
      });
      return; // Stop form submission
    }

    setFormData(data); // Save form data before verification

    // if (!isVerificationComplete) {
    //   dispatch(
    //     fetchOTPs({
    //       mobile: data.MobileNo,
    //       email: data.email,
    //       firstName: data.firstName,
    //       whatsappNo: data.WhatsApp_No,
    //     })
    //   );
    //   setisMobileAdhaarModalOpen(true); // Open the modal for verification
    //   return; // Do not continue until verification is done
    // }
    if (!isVerificationComplete) {
      try {
        await dispatch(
          fetchOTPs({
            mobile: data.MobileNo,
            email: data.email,
            firstName: data.firstName,
            whatsappNo: data?.WhatsApp_No,
          })
        ).unwrap();
        setRequireWhatsapp(!!data?.WhatsApp_No);
        setisMobileAdhaarModalOpen(true); // Open modal
        toast.success("OTP sent successfully. Please verify your details.");
      } catch (error) {
        if (error.status === 429) {
          toast.error(
            "OTP already sent. Please wait 30 seconds before trying again."
          );
        } else {
          toast.error("Failed to send OTP. Please try again.");
        }
        return; // Prevent form submission if OTP sending fails
      } finally {
        setIsLoading(false); // Stop loading after OTP attempt
      }

      return;
    }

    // Continue with form submission logic once verification is complete
    handleFormSubmit(data);
  };

  const handleFormSubmit = async (data) => {
    // Form submission logic
    const { email, mobile } = data;
    console.log(data);

    try {
      const emailResponse = await dispatch(checkEmailAsync(email));
      if (emailResponse.payload.exists === false) {
        const mobileResponse = await dispatch(checkMobileAsync(mobile));
        if (mobileResponse.payload.exists === false) {
          if (selectedOption === "without") {
            const userData = {
              ...data,
              Aadhaar_ekyc,
              role: "",
              status: "",
              Photo: uploadPhoto,
            };
            const insertUserResponse = await dispatch(
              createUserAsync(userData)
            );
            const { statusCode, message } = insertUserResponse.payload;
            if (insertUserResponse.payload.statusCode === "200") {
              toast.success("User added successfully!");
              setShowModal(true);
            } else {
              toast.error(
                message ?? "User registration failed. Please try again."
              );
            }
          }
          if (selectedOption === "with") {
            const userData = {
              ...data,
              Aadhaar_ekyc,
              state: String(data.state),
              district: String(data.district),
              role: "1",
              status: "",
            };
            const insertUserResponse = await dispatch(
              createUserAsync(userData)
            );
            const { statusCode, message } = insertUserResponse.payload;
            if (insertUserResponse.payload.statusCode === "200") {
              toast.success("User added successfully!");
              dispatch(clearAadhaarDetails());
              dispatch(clearOTPs());
              reset();
              setShowModal(true);
            } else {
              toast.error(
                message ?? "User registration failed. Please try again."
              );
            }
          }
        } else {
          console.error("Mobile number already registered");
          toast.error("Mobile number already registered");
        }
      } else {
        console.error("Email already registered");
        toast.error("Email already registered");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOTPVerified && aadhaarDetails && selectedOption === "with") {
      setAadhaar_ekyc("Y");
      setSelectedOption("with");
      setIsEkycModalOpen(false);
      const formattedDOB = aadhaarDetails.dob
        ? aadhaarDetails.dob.split("-").reverse().join("-") // Convert "11-11-1983" to "1983-11-11"
        : "";
      setValue("identificationType", "04");
      // setValue("identificationNumber", aadhaarDetails.uid || "");
      setValue("identificationNumber", aadhaarNumber || "");
      console.log(identificationType);
      setValue("DOB", formattedDOB || "");

      Object.entries(aadhaarDetails).forEach(([key, value]) => {
        setValue(key, value || ""); // Set the value or fallback to an empty string
      });
      const stateID = stateOptions.find(
        (state) =>
          state.stateName.toLowerCase() === aadhaarDetails.state.toLowerCase()
      )?.stateID;
      const districtID = districtOptions.find(
        (district) =>
          district.districtName.toLowerCase() ===
          aadhaarDetails.district.toLowerCase()
      )?.districtID;
      setValue("state", stateID);
      setValue("district", districtID);
      if (aadhaarDetails.relation) {
        const selectedRelation = relationData.find(
          (relation) =>
            relation.relation.toLowerCase() ===
            aadhaarDetails.relation.toLowerCase()
        );
        if (selectedRelation) {
          setValue("relation", selectedRelation.relatioN_CODE);
        }
      }

      if (aadhaarDetails.gender) {
        const mappedGenderCode =
          aadhaarDetails.gender === "M"
            ? "01"
            : aadhaarDetails.gender === "F"
            ? "02"
            : "";
        setValue("gender", mappedGenderCode || "");
      }
    }
    // if (selectedOption === "without") {
    //   dispatch(clearAadhaarDetails());
    // }
  }, [aadhaarDetails, setValue, isOTPVerified, selectedOption]);

  // const handleRadioChange = (e) => {
  //   const value = e.target.value;
  //   dispatch(clearAadhaarDetails());
  //   setSelectedOption(value);
  //   if (value === "with") {
  //     setIsEkycModalOpen(true); // Open e-KYC modal
  //   }
  //   if (value === "without") {
  //     setIsEkycModalOpen(false);
  //   }
  // };

  const handleRadioChange = (e) => {
    isManualChange.current = true; // Set flag when user manually changes radio
    const value = e.target.value;
    dispatch(clearAadhaarDetails());
    setSelectedOption(value);
    if (value === "with") {
      setIsEkycModalOpen(true); // Open e-KYC modal only when switching manually
    }
  };

  const handleVerificationStatusChange = (mobile, email, whatsapp) => {
    setMobileVerified(mobile);
    setEmailVerified(email);
    setWhatsappVerified(whatsapp);
  };

  const onVerificationComplete = () => {
    // Mark verification as complete when all verifications are done
    setIsVerificationComplete(true);
  };
  const onSubmitModal = () => {
    // Close the modal when verification is complete
    setisMobileAdhaarModalOpen(false);
    handleFormSubmit(formData);
  };

  return (
    <div className="w-full min-h-screen overflow-hidden">
      <div className="flex h-full">
        <div
          // className="relative 3xl:w-1/3 md:w-1/4 h-full bg-cover bg-center"
          className="relative md:w-1/3  h-full bg-cover bg-center"
          // style={{ backgroundImage: url(${Rectangle}) }}
        >
          <div className="hidden md:block absolute top-0 left-6 right-0 w-full h-full flex-col justify-between">
            {isLoading && (
              <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="absolute inset-0 bg-gray-500 opacity-50 backdrop-blur-sm"></div>

                <TypewriterAnimation />
              </div>
            )}
            <nav className="flex items-center font-semibold bg-transparent p-4">
              <a href="/" className="flex items-center text-dark">
                <img src={Logo_Dashboard} alt="logo" className="h-16 mr-2" />
                <div>
                  <h6 className="m-0 text-sm xl:text-md 3xl:text-lg ">
                    Stamp & Registration Department
                  </h6>
                  <p className="m-0 text-xs xl:text-xs 3xl:text-sm ">
                    Government of Uttarakhand
                  </p>
                </div>
              </a>
            </nav>
            <div className="flex-grow flex flex-col items-center justify-center">
              <img
                src={undraw_design_tools_}
                alt="Overlay Image"
                className="w-72 3xl:w-96 z-10"
              />
              <div className="md:w-full mt-8 ml-4 pl-2 flex justify-start items-center">
                <div className=" px-4 gap-4">
                  <h6 className="text-md 3xl:text-2xl">
                    Public Data Entry allows citizen for:
                  </h6>
                  <ol className="list-decimal ml-5 text-sm 3xl:text-lg">
                    <li>Registering Online username and password</li>
                    <li>Document entry for registration.</li>
                    <li>Upload documents and online payments</li>
                    <li>
                      Online appointments to visit sub-registrar office for
                      document registration
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col h-full md:min-h-screen justify-center items-center w-full m-4 3xl:mx-8 3xl:w-2/3 md:w-3/4 md:py-8 3xl:py-20">
          <div className="flex flex-col w-full h-full bg-gray-100 rounded-lg shadow-lg py-4 md:py-2 lg:py-4 overflow-auto md:overflow-hidden">
            <form onSubmit={handleSubmit(onSubmit)} className="mx-5">
              {/* Radio Buttons Section */}
              <div className="3xl:mb-6 mb-2 flex items-center gap-1 pl-4 border-b-2">
                <label className="flex my-2 items-center font-semibold text-gray-900">
                  Create New Account :
                </label>
                <label className="flex items-center my-2 text-gray-700">
                  <input
                    type="radio"
                    name="ekycOption"
                    value="without"
                    checked={selectedOption === "without"}
                    onChange={handleRadioChange}
                    className="mr-2"
                  />
                  Without e-KYC
                </label>
                <label className="flex items-center my-2 text-gray-700">
                  <input
                    type="radio"
                    name="ekycOption"
                    value="with"
                    checked={selectedOption === "with"}
                    onChange={handleRadioChange}
                    className="mr-2"
                  />
                  With e-KYC
                </label>
              </div>

              {errors.ekyc && (
                <p className="text-red-500 text-sm mb-4 text-center">
                  {errors.ekyc.message}
                </p>
              )}

              <div className="grid grid-cols-4 md:grid-cols-10 3xl:grid-cols-10 gap-2 3xl:gap-2 mb-2 2xl:mb-4 3xl:mb-8">
                {/* Name Fields */}
                <div className="col-span-4 md:col-span-10 3xl:col-span-10">
                  <label className="block text-md font-semibold">
                    Basic Details:
                  </label>
                </div>
                <div className="col-span-2">
                  <div className="relative">
                    {/* <input
                      id="FName"
                      type="text"
                      {...register("firstName", {
                        required: "First Name is required",
                      })}
                      disabled={identificationType === "04"}
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=" "
                    /> */}
                    <input
                      id="FName"
                      type="text"
                      {...register("firstName", {
                        required: "First Name is required",
                        pattern: {
                          value: /^[A-Za-z]+$/,
                          message: "First Name can contain only letters",
                        },
                      })}
                      disabled={identificationType === "04"}
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=" "
                      // 1) Strip anything that’s not A–Z or a–z
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(
                          /[^A-Za-z]/g,
                          ""
                        );
                      }}
                    />

                    <label
                      htmlFor="FName"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      First Name
                    </label>
                  </div>
                  {errors.firstName && (
                    <p className="text-red-500 text-xs lg:text-sm mt-1">
                      {errors.firstName.message}
                    </p>
                  )}
                </div>

                <div className="col-span-2">
                  <div className="relative">
                    <input
                      id="MName"
                      type="text"
                      {...register("middleName", {
                        pattern: {
                          value: /^[A-Za-z]+$/,
                          message: "First Name can contain only letters",
                        },
                      })}
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=" "
                      // 1) Strip anything that’s not A–Z or a–z
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(
                          /[^A-Za-z]/g,
                          ""
                        );
                      }}
                    />
                    <label
                      htmlFor="MName"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Middle Name
                    </label>
                  </div>
                </div>
                <div className="col-span-2">
                  <div className="relative">
                    <input
                      id="LName"
                      type="text"
                      {...register("lastName", {
                        required: "Last Name is required",
                        pattern: {
                          value: /^[A-Za-z]+$/,
                          message: "First Name can contain only letters",
                        },
                      })}
                      disabled={identificationType === "04"}
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=" "
                      // 1) Strip anything that’s not A–Z or a–z
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(
                          /[^A-Za-z]/g,
                          ""
                        );
                      }}
                    />
                    <label
                      htmlFor="LName"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Last Name
                    </label>
                  </div>
                  {errors.lastName && (
                    <p className="text-red-500 text-xs lg:text-sm mt-1">
                      {errors.lastName.message}
                    </p>
                  )}
                </div>

                {/* Gender and DOB Fields */}
                <div className="col-span-2 md:col-span-2 mb-1 2xl:mb-2 3xl:mb-3 relative">
                  {/* Label */}
                  <label
                    htmlFor="gender"
                    className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                  >
                    Gender:
                  </label>

                  {/* Select Input */}

                  <select
                    className="custom-input 3xl:h-10 md:h-8 text-sm  peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                    id="gender"
                    disabled={identificationType === "04"}
                    defaultValue="00"
                    {...register("gender", { required: "Gender is required" })}
                  >
                    <option value="00">Select Gender</option>
                    {genderData
                      .filter((option) => option.gendeR_CODE !== "00")
                      .map((option) => (
                        <option
                          key={option.gendeR_CODE}
                          value={option.gendeR_CODE}
                        >
                          {option.gender}
                        </option>
                      ))}
                  </select>

                  {/* Error Message */}
                  {errors.gender && (
                    <p className="text-red-500 text-xs lg:text-sm mt-1">
                      {errors.gender.message}
                    </p>
                  )}
                </div>

                <div className="col-span-2 md:col-span-2 mb-1 2xl:mb-2 3xl:mb-3 relative">
                  {/* Input */}
                  <input
                    id="DOB"
                    type="date"
                    disabled={identificationType === "04"}
                    {...register("DOB", {
                      required: "Date of Birth is required",
                    })}
                    className="custom-input  3xl:h-10 md:h-8 text-sm peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                  />
                  <label
                    htmlFor="DOB"
                    className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                  >
                    Date of Birth:
                  </label>

                  {/* Error Message */}
                  {errors.DOB && (
                    <p className="text-red-500 text-xs lg:text-sm mt-1">
                      {errors.DOB.message}
                    </p>
                  )}
                </div>

                {/* Contact Fields */}
                <div className="col-span-2 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      id="MobileNo"
                      type="text"
                      maxLength={10}
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=" "
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, ""); // Allow only digits
                      }}
                      {...register("MobileNo", {
                        required: "Mobile Number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Enter a valid 10-digit mobile number",
                        },
                      })}
                    />
                    <label
                      htmlFor="MobileNo"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Enter Mobile No
                    </label>
                    {errors.MobileNo && (
                      <p className="text-red-500 text-xs lg:text-sm mt-1">
                        {errors.MobileNo.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="col-span-2 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      id="WhatsApp_No"
                      type="text"
                      maxLength={10}
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=" "
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, ""); // Allow only digits
                      }}
                      {...register("WhatsApp_No", {
                        //required: "WhatsApp Number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Enter a valid 10-digit WhatsApp number",
                        },
                      })}
                    />
                    <label
                      htmlFor="WhatsApp_No"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Enter WhatsApp No
                    </label>
                    {errors.WhatsApp_No && (
                      <p className="text-red-500 text-xs lg:text-sm mt-1">
                        {errors.WhatsApp_No.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Email Field */}
                <div className="col-span-2 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      id="email"
                      type="email"
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=" "
                      {...register("email", {
                        required: "Email ID is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Enter a valid email address",
                        },
                      })}
                    />
                    <label
                      htmlFor="email"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Enter Email ID
                    </label>
                    {errors.email && (
                      <p className="text-red-500 text-xs lg:text-sm mt-1">
                        {errors.email.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="col-span-2">
                  <div className="relative">
                    <label
                      htmlFor="identificationType"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Id Type
                    </label>
                    <select
                      id="identificationType"
                      disabled={identificationType === "04"}
                      className="custom-input  3xl:h-10 md:h-8 text-sm peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      {...register("identificationType", {
                        required: "Identification type is required",
                        onChange: (e) => {
                          const selectedType = e.target.value;
                          setValue("identificationType", selectedType); // Update the type
                          setValue("identificationNumber", ""); // Reset number field
                          clearErrors("identificationNumber"); // Clear previous errors
                        },
                      })}
                    >
                      {idTypeData.map((option) => (
                        <option key={option.iD_CODE} value={option.iD_CODE}>
                          {option.id}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-span-2">
                  <div className="relative">
                    <input
                      id="identificationNumber"
                      disabled={identificationType === "04"}
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0 uppercase"
                      type="text"
                      maxLength={
                        identificationType === "02"
                          ? 10
                          : identificationType === "04"
                          ? 12
                          : 100
                      }
                      {...register("identificationNumber", {
                        required: "Identification number is required",
                        validate: (value) => {
                          if (identificationType === "02") {
                            return (
                              /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value) ||
                              "Enter a valid PAN (ABCDE1234F format)"
                            );
                          }
                          if (identificationType === "04") {
                            return (
                              /^[0-9]{12}$/.test(value) ||
                              "Enter a valid 12-digit Aadhaar number"
                            );
                          }
                          return true;
                        },
                        onChange: (e) => {
                          const value = e.target.value.toUpperCase();
                          setValue("identificationNumber", value); // Update value
                          // Perform validation immediately
                          if (identificationType === "02") {
                            if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
                              setError("identificationNumber", {
                                type: "manual",
                                message:
                                  "Enter a valid PAN (ABCDE1234F format)",
                              });
                            } else {
                              clearErrors("identificationNumber");
                            }
                          }
                          if (identificationType === "04") {
                            if (!/^[0-9]{12}$/.test(value)) {
                              setError("identificationNumber", {
                                type: "manual",
                                message:
                                  "Enter a valid 12-digit Aadhaar number",
                              });
                            } else {
                              clearErrors("identificationNumber");
                            }
                          }
                        },
                      })}
                      // placeholder={
                      //   identificationType === "05"
                      //     ? "Enter other identification details"
                      //     : ""
                      // }
                      placeholder=""
                    />
                    <label
                      htmlFor="identificationNumber"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Enter ID Number
                    </label>
                  </div>
                  {errors.identificationNumber && (
                    <p className="text-red-500 text-xs lg:text-sm mt-1">
                      {errors.identificationNumber.message}
                    </p>
                  )}
                </div>

                {/* Relationship Field */}
                <div className="col-span-2">
                  <div className="relative">
                    <label
                      htmlFor="relation"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Relation Type
                    </label>
                    <select
                      className="custom-input  3xl:h-10 md:h-8 text-sm peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      id="relation"
                      {...register("relation", {
                        required: "Relation is required",
                      })}
                      disabled={identificationType === "04"}
                    >
                      {relationData.map((option) => (
                        <option
                          key={option.relatioN_CODE}
                          value={option.relatioN_CODE}
                        >
                          {option.relation}
                        </option>
                      ))}
                    </select>
                    {errors.relation && (
                      <p
                        id="relation-error"
                        className="text-red-500 text-xs mt-1 ml-1"
                      >
                        {errors.relation.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Father/Husband/Guardian Name Field */}
                <div className="col-span-2">
                  <div className="relative">
                    <input
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=" "
                      type="text"
                      id="fatherName"
                      disabled={identificationType === "04"}
                      {...register("fatherName", {
                        required: "Name is required",
                      })}
                      aria-describedby="fatherName-error"
                    />
                    <label
                      htmlFor="fatherName"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Enter Name
                    </label>
                    {errors.fatherName && (
                      <p
                        id="fatherName-error"
                        className="text-red-500 text-xs mt-1 ml-1"
                      >
                        {errors.fatherName.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Category Field */}
                <div className="col-span-2">
                  <div className="relative">
                    <label
                      htmlFor="category"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Category Type
                    </label>
                    <select
                      className="custom-input  3xl:h-10 md:h-8 text-sm peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      {...register("category", {
                        required: "Category is required",
                      })}
                    >
                      <option value="">Category</option>
                      <option value="general">General</option>
                      <option value="sc">SC</option>
                      <option value="st">ST</option>
                      <option value="obc">OBC</option>
                    </select>
                    {errors.category && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.category.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Religion Field */}
                <div className="col-span-2">
                  <div className="relative">
                    <label
                      htmlFor="Relegion"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Relegion Type
                    </label>
                    <select
                      className="custom-input  3xl:h-10 md:h-8 text-sm peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      {...register("Relegion", {
                        required: "Relegion is required",
                      })}
                    >
                      <option value="">Relegion</option>
                      <option value="hindu">Hindu</option>
                      <option value="muslim">Muslim</option>
                      <option value="christian">Christian</option>
                      <option value="other">Other</option>
                    </select>
                    {errors.relegion && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.relegion.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Address Fields */}

                <div className="col-span-3 md:col-span-10 3xl:col-span-10">
                  <label className="block text-md font-semibold">
                    Address:
                  </label>
                </div>

                {/* Dropdowns for Country, District, State, Village/Town/City */}

                {/* Country Dropdown */}
                <div className="col-span-2 ">
                  <div className="relative">
                    <label
                      htmlFor="country"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      country:
                    </label>
                    <select
                      className="custom-input  3xl:h-10 md:h-8 text-sm peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      id="country"
                      disabled={identificationType === "04"}
                      {...register("country", {
                        required: "Country is required",
                      })}
                    >
                      <option value="">Country</option>
                      <option value="India">India</option>
                    </select>
                    {errors.country && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.country.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* State Dropdown */}
                <div className="col-span-2 ">
                  <div className="relative">
                    <label
                      htmlFor="State"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      State:
                    </label>
                    <select
                      className="custom-input  3xl:h-10 md:h-8 text-sm peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      id="state"
                      {...register("state", {
                        required: "state is required",
                      })}
                      disabled={identificationType === "04"}
                    >
                      <option value="">State</option>
                      {stateOptions.map((option) => (
                        <option key={option.stateID} value={option.stateID}>
                          {option.stateName}
                        </option>
                      ))}
                    </select>
                    {errors.state && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.state.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* District Dropdown */}
                <div className="col-span-2 ">
                  <div className="relative">
                    <label
                      htmlFor="District"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      District:
                    </label>
                    <select
                      className="custom-input  3xl:h-10 md:h-8 text-sm peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      id="district"
                      {...register("district", {
                        required: "district is required",
                      })}
                      disabled={identificationType === "04"}
                      // disabled={!selectedState} // Disable if no state is selected
                    >
                      <option value="">District</option>
                      {districtOptions.map((option) => (
                        <option
                          key={option.districtID}
                          value={option.districtID}
                        >
                          {option.districtName}
                        </option>
                      ))}
                    </select>
                    {errors.district && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.district.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Village/Town/City Input */}
                <div className="col-span-2 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      id="villageTownCity"
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=""
                      type="text"
                      {...register("villageTownCity", {
                        required: "Village/Town/City is required",
                      })}
                      disabled={identificationType === "04"}
                    />
                    <label
                      htmlFor="villageTownCity"
                      className="absolute text-xs xl:text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Enter Village/Town/City
                    </label>
                    {errors.villageTownCity && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.villageTownCity.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Inputs for House No., Landmark, Street, and Pincode */}

                {/* House No./Flat Input */}
                <div className="col-span-2 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      type="text"
                      id="house"
                      {...register("house", {
                        required: "House/Flat is required",
                      })}
                      disabled={identificationType === "04"}
                      placeholder=" "
                    />
                    <label
                      htmlFor="house"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      House No./Flat
                    </label>
                    {errors.house && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.house.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Landmark Input */}
                <div className="col-span-4 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=""
                      id="Landmark"
                      {...register("landmark", {
                        required: "Landmark is required",
                      })}
                      disabled={identificationType === "04"}
                      type="text"
                    />
                    <label
                      htmlFor="Landmark"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Landmark
                    </label>
                    {errors.landmark && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.landmark.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Street Input */}
                <div className="col-span-4 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=""
                      id="street"
                      {...register("street", {
                        required: "Street is required",
                      })}
                      disabled={identificationType === "04"}
                      type="text"
                    />
                    <label
                      htmlFor="Street"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Street
                    </label>
                    {errors.street && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.street.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Pincode Input */}
                <div className="col-span-2 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      id="Pincode"
                      placeholder=""
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, ""); // Allow only digits
                      }}
                      className={`custom-input ${
                        errors.pincode
                          ? "is-invalid"
                          : " custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      }`}
                      type="tel"
                      {...register("pincode", {
                        required: "Pincode is required",
                        pattern: {
                          value: /^[0-9]{6}$/,
                          message: "Pincode must be a 6-digit number",
                        },
                      })}
                      disabled={identificationType === "04"}
                      inputMode="numeric"
                      maxLength={6}
                    />
                    <label
                      htmlFor="Pincode"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Pincode
                    </label>
                    {errors.pincode && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.pincode.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="col-span-3 md:col-span-10 3xl:col-span-10">
                  <label className="text-md font-semibold">
                    Upload Profile Picture
                  </label>
                  <div className="flex items-center gap-x-4 mt-2">
                    {/* File Input */}
                    <label className="text-md ms-4 font-semibold">
                      <input
                        type="file"
                        name="uploadPhoto"
                        accept=".jpg,.jpeg,.png"
                        onChange={handleFileChange}
                        className="border rounded p-2"
                        required
                      />
                    </label>

                    {/* Preview selected file */}
                    {uploadPhoto && (
                      <img
                        src={uploadPhoto}
                        alt="preview"
                        className="w-32 h-32 object-cover border rounded"
                      />
                    )}
                  </div>
                </div>

                <div className="col-span-3 md:col-span-10 3xl:col-span-10">
                  <label className="block text-md font-semibold">
                    Account Details:
                  </label>
                </div>
                {/* Username, Password, and Confirm Password Row */}

                {/* Username Field */}
                <div className="col-span-2">
                  <div className="relative">
                    <input
                      id="username" // Add an id to match the label's htmlFor
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=""
                      type="text"
                      {...register("username", {
                        required: "Username is required",
                        minLength: {
                          value: 4,
                          message:
                            "Username must be at least 4 characters long",
                        },
                      })}
                    />
                    <label
                      htmlFor="username" // Match this with the input's id
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Enter Username
                    </label>
                    {errors.username && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.username.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Password Field */}
                <div className="col-span-2 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      id="Password"
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=""
                      type={showPassword ? "text" : "password"}
                      {...register("password", {
                        required: "Password is required",
                        minLength: {
                          value: 6,
                          message:
                            "Password must be at least 6 characters long",
                        },
                      })}
                    />
                    <label
                      htmlFor="Password"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Enter Password
                    </label>
                    <button
                      type="button"
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <i className="fas fa-eye-slash"></i>
                      ) : (
                        <i className="fas fa-eye"></i>
                      )}
                    </button>
                  </div>
                  {errors.password && (
                    <p className="text-red-500 text-xs mt-1 ml-1">
                      {errors.password.message}
                    </p>
                  )}
                </div>

                {/* Confirm Password Field */}
                <div className="col-span-2 mb-1 2xl:mb-2 3xl:mb-3">
                  <div className="relative">
                    <input
                      id="Cpassword"
                      className="custom-input 3xl:h-10 md:h-8 peer border-b-2 focus:border-gray-100 focus:outline-none focus:ring-0"
                      placeholder=""
                      type={showConfirmPassword ? "text" : "password"}
                      {...register("confirmPassword", {
                        required: "Confirm Password is required",
                        validate: (value) =>
                          value === getValues("password") ||
                          "Passwords do not match",
                      })}
                    />
                    <label
                      htmlFor="Cpassword"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0]  px-2 
                 peer-focus:px-2 peer-focus:text-black peer-focus:dark:text-black 
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-3.5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >
                      Confirm Password
                    </label>
                    <button
                      type="button"
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? (
                        <i className="fas fa-eye-slash"></i>
                      ) : (
                        <i className="fas fa-eye"></i>
                      )}
                    </button>
                  </div>
                  {errors.confirmPassword && (
                    <p className="text-red-500 text-xs mt-1 ml-1">
                      {errors.confirmPassword.message}
                    </p>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              {status === "loading" && <div>Loading...</div>}

              {/* Submit Button */}
              <div className="mb-6 flex justify-center space-x-4">
                <button
                  className="w-1/5 bg-blue-500 text-white py-1 rounded-md"
                  type="submit"
                  // onClick={() => {
                  //   setisMobileAdhaarModalOpen(true);
                  // }}
                >
                  Submit
                </button>
                <button
                  className="w-1/5 py-1 border border-blue-500 text-blue-500 rounded-md"
                  type="reset"
                >
                  Reset
                </button>
              </div>
              <div className="flex justify-center">
                <p>
                  Already have an account?{" "}
                  <a className="text-blue-500" href="/Login">
                    Login
                  </a>
                </p>
              </div>
            </form>

            {showModal && (
              <RegistrationSuccessModal onClose={() => setShowModal(false)} />
            )}
          </div>
          {isEkycModalOpen && (
            <EkycModal
              isOpen={isEkycModalOpen}
              onClose={(e) => {
                handleEkycModalClose(e);
              }}
              onAadhaarChange={handleAadhaarNumberChange}
              // identificationNumber=""
              // onEkycSuccess={handleEkycSuccess}
            />
          )}

          {isMobileAdhaarModalOpen && (
            <MobileEmailModal
              onClose1={() => setisMobileAdhaarModalOpen(false)}
              mobileVerified={mobileVerified}
              emailVerified={emailVerified}
              whatsappVerified={whatsappVerified}
              onVerificationStatusChange={handleVerificationStatusChange}
              onVerificationComplete={onVerificationComplete} // Pass this function
              onSubmitModal={onSubmitModal}
              requireWhatsapp={requireWhatsapp}
              mobileNo={formData?.MobileNo || ""}
              emailAddr={formData?.email || ""}
              whatsappNo={formData?.WhatsApp_No || ""}
              firstName={formData?.firstName || ""}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SignUpNew;
